import React from "react";

export const TickIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon-/-navigation-/-tick" fill="#4A4A4A">
        <path
          d="M56.0451972,12 L27.985246,40.4293732 L13.9552705,26.2146866 L9,31.2351954 L25.5050971,47.9623279 C26.8752411,49.3458907 29.0947833,49.3458907 30.4649273,47.9623279 L61,17.0205088 L56.0451972,12 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
);

export const DownArrowIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icon-/-b2b-/-arrow-down"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M34.7574116,40.8571429 C35.5409131,40.8565048 36.2923127,40.5460724 36.8461743,39.9947282 L50.7575758,26.1555825 L46.5802965,22 L34.7575758,33.7613136 L22.934855,22 L18.7575758,26.1555825 L32.6689772,39.9947282 C33.222847,40.5460398 33.9742384,40.8564895 34.75774,40.8571429 L34.7574116,40.8571429 Z"
        id="Path"
        fill="#4A4A4A"
      ></path>
    </g>
  </svg>
);

export const ClockIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icon-/-b2b-/-clock"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M35,0 C52.1208272,0 66,13.8791728 66,31 C66,48.1208272 52.1208272,62 35,62 C18.050381,62 4.27790762,48.3970228 4.00415311,31.5126417 L4,31 L4,28 L10,28 L10,31 C10,44.8071187 21.1928813,56 35,56 C48.8071187,56 60,44.8071187 60,31 C60,17.3309524 49.0298571,6.22411905 35.4134207,6.00334929 L35,6 L32,6 L32,0 L35,0 Z M36,15 L36,29 C36,29.5522847 36.4477153,30 37,30 L37,30 L49,30 L49,36 L37,36 C33.1340068,36 30,32.8659932 30,29 L30,29 L30,15 L36,15 Z M12.6413,14.275 C14.0827632,15.1034271 14.5797271,16.9435368 13.7513,18.385 C12.9228729,19.8264632 11.0827632,20.3234271 9.6413,19.495 C8.1998368,18.6665729 7.70287288,16.8264632 8.5313,15.385 C9.35972712,13.9435368 11.1998368,13.4465729 12.6413,14.275 Z M19.479594,4.40858429 C20.9144719,3.58015716 22.7492431,4.07178263 23.5776702,5.5066605 C24.4060974,6.94153837 23.9144719,8.77630959 22.479594,9.60473671 C21.0447162,10.4331638 19.2099449,9.94153837 18.3815178,8.5066605 C17.5530907,7.07178263 18.0447162,5.23701141 19.479594,4.40858429 Z"
        id="Combined-Shape"
        fill="#4A4A4A"
      ></path>
    </g>
  </svg>
);

export const NavigationLeftIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon-/-navigation-/-arrow-left" fill="#4A4A4A">
        <path
          d="M40.8123554,47 L45,42.8227208 L33.1479428,31 L45,19.1772792 L40.8123554,15 L26.8664348,28.9114014 C26.3118326,29.4655915 26,30.2169911 26,31.0001642 C26,31.7833374 26.3118655,32.5347369 26.8664348,33.088927 L40.8123554,47 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
);

export const NavigationRightIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon-/-navigation-/-arrow-right" fill="#4A4A4A">
        <path
          d="M30.1876446,47 L44.1335652,33.0887413 C44.6881674,32.534557 45,31.7831651 45,31 C45,30.2168349 44.6881345,29.465443 44.1335652,28.9112587 L30.1876446,15 L26,19.1772364 L37.8520572,30.9998358 L26,42.8224352 L30.1876446,47 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
);

export const LearnIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icon-/-b2b-/-learn"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M13.421587,60.260849 C16.062187,58.838949 18.999687,58.065549 21.999687,57.999149 C24.999687,58.065555 27.937187,58.838989 30.577787,60.260849 L33.206687,61.581149 L33.210594,61.577243 C34.335594,62.143653 35.663694,62.143653 36.788694,61.577243 L39.417594,60.256943 L39.4215,60.26085 C42.0621,58.83895 44.9996,58.06555 47.9996,57.99915 C50.9996,58.065556 53.9371,58.83899 56.5777,60.26085 C58.8629,61.40145 61.3863,61.99915 63.941,61.99915 L64.9996,61.99915 L64.9996,21.53015 L60.1598,19.10825 C56.9957,17.46765 53.5465,16.44415 49.9998,16.10045 L49.9998,14.99885 C49.9998,9.63945 47.1404,4.68685 42.4998,2.00685 C37.8592,-0.66895 32.1408,-0.66895 27.4998,2.00685 C22.8592,4.68655 19.9998,9.63965 19.9998,14.99885 L19.9998,16.10045 C16.4529,16.44029 13.0037,17.45985 9.8398,19.10045 L5,21.53015 L5,61.99915 L6.0586,61.99915 C8.6133,61.99915 11.1367,61.40149 13.4219,60.26085 L13.421587,60.260849 Z M58.999587,25.237849 L58.999587,54.768849 C55.597287,53.007149 51.831587,52.057949 47.999587,51.999349 C44.538687,52.038411 41.128487,52.823569 37.999587,54.300149 L37.999587,24.738149 L38.530837,24.476429 L38.530837,24.480336 C41.444937,22.917836 44.691037,22.070136 47.999637,21.999836 C51.308237,22.066242 54.550437,22.913896 57.468437,24.468636 L58.999587,25.237849 Z M34.999587,5.999849 C39.968387,5.999849 43.999587,10.031049 43.999587,14.999849 L43.999587,16.351449 C41.159787,16.859259 38.409787,17.785049 35.839387,19.101449 L34.999547,19.523329 L34.159707,19.101449 C31.589407,17.785049 28.839407,16.859249 25.999507,16.351449 L25.999507,14.999849 C25.999507,10.031049 30.030707,5.999849 34.999507,5.999849 L34.999587,5.999849 Z M10.999587,25.237849 L12.530787,24.476129 L12.530787,24.480036 C15.444887,22.917536 18.690987,22.069836 21.999587,21.999536 C25.308187,22.065942 28.550387,22.913596 31.468387,24.468336 L31.999637,24.730056 L31.999637,54.300056 C28.870737,52.823456 25.460537,52.038356 21.999637,51.999256 C18.167637,52.05785 14.401937,53.007056 10.999587,54.768756 L10.999587,25.237849 Z"
        id="Shape"
        fill="#4A4A4A"
      ></path>
    </g>
  </svg>
);

export const LeftArrowIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icon-/-b2b-/-left-arrow"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M43.9845967,34.644 L27.3695,51.532956 L23.1,47.263456 L39.7150967,30.3745 L23.738665,14.1892548 L28.008165,9.91975476 L43.9845967,26.105 C45.5672609,27.6058148 46.358593,29.0289814 46.358593,30.3745 C46.358593,31.7200186 45.5672609,33.1431852 43.9845967,34.644 Z"
        id="Path"
        fill="#4A4A4A"
        transform="translate(34.729296, 30.726355) scale(-1, 1) translate(-34.729296, -30.726355) "
      ></path>
    </g>
  </svg>
);

export const MedalIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icon-/-b2b-/-medal"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M55.3066623,4 L46.8783941,20.8547126 C44.9147827,19.6433312 42.7565459,18.7709166 40.5009535,18.2776708 L47.6269071,4 L39.9337472,4 L35.9999081,11.87879 L32.0660689,4 L24.3729091,4 L31.4955114,18.2407332 L31.4988686,18.2407332 C29.2432762,18.7373463 27.0850394,19.6063936 25.121428,20.817775 L16.6931599,4 L9,4 L19.8113768,25.6127909 C16.5958042,29.6864068 15.0350202,34.8205614 15.4411987,39.9944024 C15.8473428,45.168587 18.1868347,49.9976198 21.99986,53.5204359 C25.8095341,57.0437675 30.8108485,59 36,59 C41.1891515,59 46.1901222,57.0437675 50.00014,53.5204359 C53.8131653,49.9971043 56.1527088,45.1685011 56.5588013,39.9944024 C56.9649455,34.8202178 55.4041099,29.686235 52.1886232,25.6127909 L63,4 L55.3066623,4 Z M35.9996503,52.104781 C32.354441,52.104781 28.8569409,50.6551949 26.2795506,48.0781531 C23.7021603,45.5011113 22.251707,42.0046668 22.251707,38.3609873 C22.251707,34.7173079 23.7017307,31.2204339 26.2795506,28.6438216 C28.8573705,26.0672093 32.3548707,24.6171937 35.9996503,24.6171937 C39.6444299,24.6171937 43.1423597,26.0667797 45.71975,28.6438216 C48.2971402,31.2208634 49.7475936,34.7173079 49.7475936,38.3609873 C49.7475936,42.0046668 48.2975699,45.5015408 45.71975,48.0781531 C43.14193,50.6547654 39.6444299,52.104781 35.9996503,52.104781 L35.9996503,52.104781 Z"
        id="Shape"
        fill="#4A4A4A"
      ></path>
    </g>
  </svg>
);

export const NewWindowIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icon-/-b2b-/-new-window"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M15.5293,47.4707 L15.5293,14.4707 C15.5293,12.8145 16.8731,11.4707 18.5293,11.4707 L52.5293,11.4707 C54.1855,11.4707 55.5293,12.8145 55.5293,14.4707 L55.5293,29.4707 L61.5293,29.4707 L61.5293,14.4707 C61.525394,9.8887 58.084,6.041 53.5293,5.5293 L17.5293,5.5293 C12.9746,6.04102 9.5332,9.8887 9.5293,14.4707 L9.5293,47.4707 C9.5293,52.4395 13.5605,56.4707 18.5293,56.4707 L34.5293,56.4707 L34.5293,50.4707 L18.5293,50.4707 C16.8731,50.4707 15.5293,49.1269 15.5293,47.4707 Z"
        id="Path"
        fill="#4A4A4A"
        transform="translate(35.529300, 31.000000) scale(1, -1) translate(-35.529300, -31.000000) "
      ></path>
      <path
        d="M50.1930431,32.6817232 L54.4330431,36.9217232 L66.5530431,24.8017232 C67.7228566,23.630453 67.7228566,21.7329934 66.5530431,20.5617232 L54.4330431,8.4417232 L50.1930431,12.6817232 L57.1930431,19.6817232 L21.4330431,19.6817232 L21.4330431,25.6817232 L57.1930431,25.6817232 L50.1930431,32.6817232 Z"
        id="Path"
        fill="#4A4A4A"
        fillRule="nonzero"
        transform="translate(44.431723, 22.681723) rotate(-45.000000) translate(-44.431723, -22.681723) "
      ></path>
    </g>
  </svg>
);

export const PlayIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icon-/-b2b-/-play"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M35.0001,-2.84217094e-14 C26.7774,-2.84217094e-14 18.8951,3.2656 13.0781,9.0781 C7.2656,14.8945 4,22.7771 4,31.0001 C4,39.2231 7.2656,47.1051 13.0781,52.9221 C18.8945,58.7346 26.7771,62.0002 35.0001,62.0002 C43.2231,62.0002 51.1051,58.7346 56.9221,52.9221 C62.7346,47.1057 66.0002,39.2231 66.0002,31.0001 C66.0002,22.7771 62.7346,14.8951 56.9221,9.0781 C51.1057,3.2656 43.2231,-2.84217094e-14 35.0001,-2.84217094e-14 Z M35.0001,56 C28.3712,56 22.0121,53.3672 17.3241,48.6758 C12.6327,43.9883 9.9999,37.6288 9.9999,30.9998 C9.9999,24.3708 12.6327,18.0118 17.3241,13.3238 C22.0116,8.6324 28.3711,5.9996 35.0001,5.9996 C41.6291,5.9996 47.9881,8.6324 52.6761,13.3238 C57.3675,18.0113 60.0003,24.3708 60.0003,30.9998 C60.0003,37.6288 57.3675,43.9878 52.6761,48.6758 C47.9886,53.3672 41.6291,56 35.0001,56 Z M29.5,44.9964193 C30.6094,44.9964193 31.6953,44.6878293 32.6406,44.1057993 L45.6406,36.1057993 C47.414,35.0159993 48.4961,33.0784993 48.4961,30.9963993 C48.4961,28.9142993 47.4141,26.9768993 45.6406,25.8869993 L32.6406,17.8869993 C30.789,16.7502993 28.4687,16.7033993 26.5703,17.7619993 C24.6758,18.8205993 23.5,20.8244993 23.5,22.9963993 L23.5,38.9963993 C23.5,42.3088993 26.1875,44.9964193 29.5,44.9964193 L29.5,44.9964193 Z M29.5,22.9964193 L42.5,30.9964193 L29.5,38.9964193 L29.5,22.9964193 Z"
        id="Combined-Shape"
        fill="#4A4A4A"
      ></path>
    </g>
  </svg>
);

export const RightArrowIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icon-/-b2b-/-right-arrow"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M43.9845967,34.644 L27.3695,51.532956 L23.1,47.263456 L39.7150967,30.3745 L23.738665,14.1892548 L28.008165,9.91975476 L43.9845967,26.105 C45.5672609,27.6058148 46.358593,29.0289814 46.358593,30.3745 C46.358593,31.7200186 45.5672609,33.1431852 43.9845967,34.644 Z"
        id="Path"
        fill="#4A4A4A"
      ></path>
    </g>
  </svg>
);

export const SuccessIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icon-/-b2b-/-success"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M13.5137245,38.8863409 C14.1696384,38.6365909 14.8987386,38.6668611 15.5344894,38.9695952 C16.1676697,39.2697784 16.6520746,39.8147321 16.8766069,40.480715 C17.098614,41.1467624 17.0405918,41.8758173 16.7176725,42.4964239 C16.3922343,43.119588 15.8271254,43.5837545 15.1535156,43.7805333 C11.5762147,44.96822 9.16439058,48.3162821 9.16691323,52.085298 L9.16691323,52.085298 L9.16691323,56.8332028 L13.9148614,56.8332028 C17.6837181,56.8357216 21.0314879,54.4239879 22.219702,50.8466552 C22.7091186,49.5474268 24.1395223,48.8687985 25.4564521,49.3102834 C26.7733561,49.7517747 27.5049687,51.1544591 27.1139327,52.4864894 C26.1931604,55.2591144 24.4221413,57.6709126 22.0532048,59.3788176 C19.6814911,61.0867226 16.8357318,62.0025174 13.9143448,61.9999948 L13.9143448,61.9999948 L6.5827832,61.9999948 C5.89728348,62.0006342 5.24138256,61.7281573 4.75699057,61.2437827 C4.27259859,60.759408 4.00012695,60.1035002 4.00012695,59.4173028 L4.00012695,59.4173028 L4.00012695,52.0858082 C3.99761336,49.164125 4.91341272,46.3184562 6.62133331,43.9470226 C8.32938307,41.5781723 10.7411387,39.8071694 13.5137245,38.8863409 Z M63.4166093,2.04035332e-05 C64.1028129,2.04035332e-05 64.7587139,0.272579108 65.2431058,0.756953748 C65.7274978,1.24132839 65.9999822,1.89723623 65.9999822,2.58343364 L65.9999822,2.58343364 L65.9999822,7.85355889 C66.0050018,13.2398049 64.9479575,18.5756759 62.894384,23.5531097 C60.1676528,30.1018549 55.8079829,35.8412423 50.2275485,40.2233473 C50.4016279,40.5689971 50.4949697,40.9474164 50.500015,41.3334048 L50.500015,41.3334048 L50.500015,43.6594365 C50.4849023,47.9658499 48.9863627,52.1358635 46.2566606,55.4684902 C43.5267002,58.798469 39.7299433,61.0891735 35.5092578,61.9494229 C35.3427542,61.9822189 35.1712,61.9973559 34.9996523,61.9998841 C33.7760462,62.0023973 32.7190148,61.1446667 32.4667373,59.9463238 L32.4667373,59.9463238 L32.4692599,59.9463238 L30.0398083,47.7917495 L18.2080423,35.9600917 L6.07337788,33.5256247 C5.40228683,33.3919373 4.81195145,32.9958545 4.43352869,32.4282255 C4.05258458,31.8580843 3.91635393,31.1618119 4.05006193,30.490727 C4.91025457,26.2695634 7.20098005,22.4730996 10.5310538,19.7434225 C13.8635818,17.0138099 18.0337627,15.5152439 22.3402155,15.5001069 L22.3402155,15.5001069 L24.6662684,15.5001069 C25.0522862,15.5051573 25.430709,15.5984995 25.776336,15.7725708 C33.5593389,5.80498031 45.5021892,-0.0125728881 58.1464203,2.04035332e-05 L58.1464203,2.04035332e-05 Z M45.3331086,43.5282103 C43.7689517,44.4540763 42.1442797,45.2740257 40.4691032,45.9778543 L40.4691032,45.9778543 L40.4691032,45.9753317 L35.3680103,48.0818447 L36.9750509,56.1295679 C39.4448675,55.1078603 41.5564373,53.3797408 43.0449019,51.1596904 C44.5308477,48.9398337 45.3280633,46.3312502 45.3331086,43.6596334 L45.3331086,43.6596334 Z M60.8337554,5.16771606 L58.146937,5.16771606 C53.436835,5.16263495 48.7694874,6.08850093 44.4151134,7.8872746 C35.5374138,11.567876 28.4836921,18.6216625 24.8029279,27.4992809 L24.8029279,27.4992809 L22.5424922,32.9762664 L33.0244552,43.4581336 L38.5014908,41.1977186 C47.3791903,37.5171172 54.4329121,30.4633307 58.1136763,21.5857123 C59.9124018,17.2315072 60.838284,12.5640732 60.8332387,7.8540142 L60.8332387,7.8540142 L60.8337554,5.16771606 Z M34.9996885,33.5833493 C34.9996885,37.02693 29.8329784,37.02693 29.8329784,33.5833493 C29.8329784,30.1397685 34.9996885,30.1397685 34.9996885,33.5833493 Z M42.7496244,15.4999002 C47.0308249,15.4999002 50.4996895,18.968733 50.4996895,23.2498944 C50.4996895,26.3857359 48.6126778,29.2112546 45.7164785,30.4095974 C42.8204083,31.6103945 39.4852324,30.9469304 37.2701992,28.7293987 C35.0526279,26.5144503 34.3891125,23.1793695 35.5899851,20.2831966 C36.7883389,17.3870884 39.6138835,15.4999002 42.7497536,15.4999002 Z M22.4711399,20.6666276 L22.3397763,20.6666276 C19.6683289,20.6716651 17.0597216,21.4688812 14.8396509,22.9548134 C12.6195801,24.4431998 10.8914448,26.5548149 9.86972788,29.0246089 L9.86972788,29.0246089 L17.9149413,30.6316348 L20.0214735,25.5305886 C20.7253732,23.8554919 21.5452655,22.2308348 22.4711399,20.6666276 L22.4711399,20.6666276 Z M43.73872,20.8634193 C42.7724806,20.4622861 41.6624323,20.6842588 40.9232505,21.4234791 C40.1840687,22.1626994 39.9620616,23.2726923 40.3631856,24.2389229 C40.7617973,25.2051792 41.7053031,25.833355 42.7497536,25.833355 C43.4360154,25.8332969 44.0919163,25.56082 44.5763083,25.0764454 C45.0607003,24.5920707 45.3331667,23.9361629 45.3331667,23.2499655 C45.3331667,22.2055246 44.7049593,21.2620209 43.73872,20.8634193 Z"
        id="Combined-Shape"
        fill="#4A4A4A"
      ></path>
    </g>
  </svg>
);

export const crossIcon = (
  <svg
    width="70px"
    height="62px"
    viewBox="0 0 70 62"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon-/-navigation-/-cancel" fill="#4A4A4A">
        <polygon
          id="Path"
          points="56.2157135 46.6420975 51.9462135 50.9115975 35.3785 34.644 18.7634033 51.532956 14.4939033 47.263456 31.109 30.3745 15.1325684 14.1892548 19.4020684 9.91975476 35.3785 26.105 51.263456 10.4939033 55.532956 14.7634033 39.648 30.3745"
        ></polygon>
      </g>
    </g>
  </svg>
);
